module.exports = __webpack_public_path__ + "static/media/partner2.97dbad8c.png";